import { FC } from 'react';

import { useAppDarkMode } from '@store/selectors';
import { getSpotPriceColors } from './settings';

export const SpotPriceSVGFilters: FC = () => {
    const colors = getSpotPriceColors();
    const { isDarkMode } = useAppDarkMode();

    return (
        <svg
            style={{
                width: 0,
                height: 0,
                position: 'absolute',
            }}
        >
            <defs>
                <filter id="tooltip-shadow">
                    <feDropShadow
                        dx={0}
                        dy={2}
                        stdDeviation={2}
                        floodOpacity={0.5}
                    />
                    <feDropShadow
                        dx={0}
                        dy={-2}
                        floodColor={colors.turquoise}
                        stdDeviation={0}
                    />
                </filter>

                <filter
                    x={0}
                    y={0}
                    id="axis-label-background"
                    width={1}
                    height={1}
                >
                    <feFlood
                        result="bg"
                        floodColor={colors[isDarkMode ? 'darkest' : 'white']}
                    />

                    <feMerge>
                        <feMergeNode in="bg" />
                        <feMergeNode in="SourceGraphic" />
                    </feMerge>
                </filter>

                <pattern
                    id="diagonal-hatch"
                    width={6}
                    height={6}
                    patternUnits="userSpaceOnUse"
                >
                    <rect
                        x={0}
                        y={0}
                        width="100%"
                        height="100%"
                        fill={colors.turquoise}
                        fillOpacity={0.3}
                    />

                    <path
                        d="M5 0h1L0 6V5zM6 5v1H5z"
                        stroke={colors.turquoise}
                        strokeWidth={1}
                        strokeOpacity={0.5}
                    />
                </pattern>
            </defs>
        </svg>
    );
};

export default SpotPriceSVGFilters;
